import { Education } from "./Education";

import { Column } from "@/components/Column";
import { SheetSectionEmptyText } from "@/components/SheetSectionEmptyText";
import { EducationType } from "@/types";

export const EducationsView = ({
  educations,
}: {
  educations: EducationType[];
}) => {
  if (!educations.length) {
    return (
      <SheetSectionEmptyText text="This candidate hasn't added any educational background." />
    );
  }

  return (
    <Column className="gap-4">
      {educations.map((education: EducationType) => {
        return <Education education={education} key={education.id} />;
      })}
    </Column>
  );
};
